import styled, { css } from 'styled-components';
import { HEADER_HEIGHT } from '@/components/Header/Header.constants';

export const HeaderBox = styled.header<{
  $isMain?: boolean;
}>`
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  height: ${HEADER_HEIGHT}px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  z-index: 10;

  ${({ $isMain, theme }) =>
    theme.isWebView
      ? css`
          position: fixed;
          top: 0;
          z-index: 11;
        `
      : $isMain &&
        css`
          border-bottom: none;
        `}

  @media (min-width: 950px) {
    height: 74px;
    border-bottom: none;
  }
`;

export const desktopHeaderMediaStyles = css`
  @media (min-width: 1340px) {
    max-width: 1280px;
    margin: 0;
  }
`;

export const HeaderContent = styled.div<{
  $isMain?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
  margin: 0 15px;

  @media (min-width: 744px) {
    margin: 0 30px;
  }

  ${desktopHeaderMediaStyles}
`;

export const headerBtnTextStyles = css`
  @media (max-width: 1310px) {
    span {
      display: none;
    }
  }
`;
